<template>

  <div class="container-fluid">
    <div class="row">


      <!-- Left Panel -->
      <div class="col-lg-5 item-left">


        <div class="form-container">

          <div id="Logo">
            <!-- <img src="/static/visity/logo2.png" id="msd-logo"> -->
            <a href="https://www.visity.app/" target="_blank" class="link">
              <img id="image" src="/static/img/visity2.png" width="40%">
            </a>
          </div>
            <h2 id="title">Sign Up - 15 day free trial</h2>

            <p>We are confident you'll love it!!</p>

            <h5 v-if="ErrorMessage == true" class="error">
              Please enter the fields marked *
            </h5>


            <form class="text-center" @submit.prevent="SendOTP" v-if="!showOTP">

              <div class="form-group col-md-12">
                <input type="tel" class="form-control EnterMobile" v-model="FormInfo.Mobile" minlength="12" maxlength="13" placeholder="+1" required>
              </div>

              <div class="form-group col-md-12 button">
                <input type="submit" value="Next" class="btn btn-primary btn-block Next" />
              </div>

          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">Organization Name <b>*</b></label>
            <input type="text" class="form-control" v-model="FormInfo.CompanyName" placeholder="" required>
          </div>

          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">Your Name <b>*</b></label>
            <input type="text" class="form-control" v-model="FormInfo.ContactPerson" placeholder="" required>
              <small id="passwordHelpBlock" class="form-text text-muted">
                What your mum calls you
              </small>
          </div>

          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">Designation <b>*</b></label>
            <input type="text" class="form-control" v-model="FormInfo.Designation" placeholder="" required>
          </div>


<!--           <div class="form-group col-md-12">
            <label for="exampleInputEmail1">Country Code <b>*</b></label>
                        <autocomplete
                          ref="autocompleteClient"
                          placeholder=""
                          :source="CountryCodeList"
                          input-class="form-control"                           
                          resultsDisplay="name"
                          v-model="CountryCode"
                          @selected="SelectCountryCode">
                        </autocomplete>
          </div> -->

              <div class="form-group col-md-12">
                <label for="exampleInputEmail1">Country Code<b>*</b></label>
                  <select class="form-control" v-model="FormInfo.CountryCode" required @change="SelectCountryCode()">
                    <option value="+1">USA (+1)</option>
                    <option value="+91">India (+91)</option>
                  </select>
              </div>


          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">Mobile <b>*</b></label>
            <input type="tel" class="form-control" v-model="FormInfo.Mobile" minlength="10" maxlength="13" placeholder="" required @change="CheckMobileFormat()">
<!--               <small id="passwordHelpBlock" class="form-text text-muted">
                This will be used for administrator login
              </small> -->
              <small id="passwordHelpBlock" class="form-text mobileInvalid" v-if="!ValidMobile">
                Please Include Country Code
              </small>

          </div>

          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">Email <b>*</b></label>
            <input type="email" class="form-control" v-model="FormInfo.Email" required>
          </div>

            </form>


            <form class="text-center" @submit.prevent="VerifyOTP" v-if="showOTP">

              <div class="form-group col-md-12">
                <input type="tel" class="form-control EnterMobile" v-model="FormInfo.OTP" minlength="6" maxlength="6" placeholder="Enter 6 Digit OTP" required>
              </div>

              <div class="form-group col-md-12 button">
                <input type="submit" value="Verify" class="btn btn-primary btn-block Next" />
              </div>

            </form>

            <div v-if="ShowLoading">
              <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw loading"></i>
            </div>

            <transition name="fade">
              <h5 v-if="LoginError == true" class="error">
                Sorry, please check the above details and try again
              </h5>
            </transition>

          </div>

      </div>


      <!-- Right Panel -->
      <div class="col-lg-7 item-right">

        <!-- <div id="Logo">
          <img src="/static/img/logo.png" id="msd-logo">
        </div> -->

      </div>
      <!-- End of Left Panel -->




    </div>
  </div>
</template>

<script>

import { db } from '../main.js';
import axios from 'axios';
import {
  globalStore
} from '../main.js';

export default {
  name: 'Login',
  data(router) {
    return {
      username: '',
      email: '',
      password: '',
      mobile:'',
      ErrorMessage: false,
      LoginError: false,
      ShowLoading: false,
      FormInfo: {},
      showOTP: false,
      OTP: ''
    }
  },
  mounted: function() {
    // this.CheckLogin();

    this.FormInfo.Mobile = "+1";

  },
  methods: {
    CheckLogin() {
      if(localStorage.getItem('AdminInfo')){
        console.log("Admin Object Set")
        console.log(localStorage.getItem('AdminInfo'));
        this.$router.push('/dash')
      }
      else{
        console.log("admin object not set")
        this.$router.push('/')
      }
    },
    SendOTP(){

      this.showOTP = true;

      console.log(this.FormInfo.Mobile);
      console.log("MSG 91: "+this.FormInfo.Mobile.includes("+91"));

        console.log("--- Send OTP ---");
        console.log("Mobile: "+this.FormInfo.Mobile);

        this.OTP = Math.floor(100000 + Math. random() * 900000);
        console.log("OTP: ",this.OTP);

        var sms = "Verification Code is "+this.OTP+" for Visity Admin Login.";

        let data = {
          Mobile: this.FormInfo.Mobile,
          Code: this.OTP
        };

        console.log("SMS Payload: "+JSON.stringify(data));

      if(this.FormInfo.Mobile.includes("+91")){

          axios.post("https://us-central1-visity-fcbd6.cloudfunctions.net/widgets", data).then((res) => {
            console.log("Send SMS Success: ",res);
          }).catch((e) => {
            console.log("Send SMS Error: ",e);
          });

      }else{

          axios.post("https://us-central1-visity-fcbd6.cloudfunctions.net/widgets/send-otp-twilio", data).then((res) => {
            console.log("Send SMS Success: ",res);
          }).catch((e) => {
            console.log("Send SMS Error: ",e);
          });

      }


    },
    VerifyOTP(){

      // --- Show Loading ---
      this.ShowLoading = true;
      console.log("ShowLoading: "+this.ShowLoading);

      console.log("OTP: ", this.OTP);
      console.log("Entered OTP: ", this.FormInfo.OTP);

      if(this.FormInfo.OTP == this.OTP){
        console.log("OTP Verified");

        db.collection("business")
          .where('Mobile','==',this.FormInfo.Mobile)
          .get()
          .then((snap) => {
            console.log(snap.docs.length)

            if(snap.docs.length == 1){

              snap.docs.forEach(doc => {
                console.log("DocId: " + doc.id);
                console.log("Name: " + doc.data().BusinessName);
                console.log("Mobile: " + doc.data().Mobile);
                console.log("Doc is data: " + JSON.stringify(doc.data()));

                localStorage.setItem("AdminInfo",JSON.stringify(doc.data()))
                localStorage.setItem("AdminId",doc.id);
                localStorage.setItem("AdminName",doc.data().Name);
                localStorage.setItem("AdminMobile",doc.data().Mobile);

                this.$router.push("/dash");

              })

            }else{
              alert('User Does Not Exist');
            } 

          })
          .catch(function(error) {
            alert('Network Error!');
            console.log("Error getting document:", error);
          });

      }else{
        alert("Incorrect OTP. Please Try Again.");
      }


    },

    AdminLogin() {

      // --- Show Loading ---
      this.ShowLoading = true;
      console.log("ShowLoading: "+this.ShowLoading);

      console.log("Company login");

      if (this.email != "" && this.password != "") {

        db.collection("company")
          .where('Email','==',this.email)
          .where('Password','==',this.password)
          .get()
          .then((snap) => {

            console.log(snap.docs.length)

            if(snap.docs.length === 1 ){

              console.log("Successful");

            snap.docs.forEach(doc => {
              console.log("Doc is: " + doc.id);
              console.log("Doc is data: " + JSON.stringify(doc.data()));

              localStorage.setItem("AdminInfo",JSON.stringify(doc.data()))
              localStorage.setItem("AdminId",doc.id);
              localStorage.setItem("CompanyName",doc.data().Name);
              localStorage.setItem("PricePlan",doc.data().PricePlan);
              localStorage.setItem("Appointment",doc.data().Appointment);

              this.$router.push("/dash");

            })
            }
            else {
              // --- Hide Loading ---
              this.ShowLoading = false;
              console.log('invalid ')
              this.LoginError = true;

              setTimeout(()=>{
                this.LoginError = false;
              },2000);

                swal('Incorrect Mobile or Password. Please Try Again!');
            }

          })
          .catch(function(error) {
            console.log("Error getting document:", error);
          });

        } else {
          this.ErrorMessage = true;
        }

    }

  }
}
</script>


<style>

#title{
  font-weight: bold;
  color: #2c3e50;

}

  #msd-logo{
    width: 180px;
  }

.container-fluid, .item-left, .item-right{
  height: 100vh;
}

.item-left{
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
}

#Logo{
  align-self: center;
  text-align: center;
}

.item-right{
  /* border: 1px solid red; */
  background-color: #039BE5;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
  /* background-image: url('/static/img/background.jpg'); */
  /*background-image: url('/static/img/bg-reception.jpg');*/
  background-image: linear-gradient( rgba(96,96,96, 0.2), rgba(96,96,96, 0.2)), url('/static/img/bg2.jpg');
   /*background-image: linear-gradient( rgba(112,112,112, 0.7), rgba(112,112,112, 0.7)), url('/static/img/bg-2.jpg'); */
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover
}

.form-container{
  align-self: center;
  /* padding: 2em; */
  /* border: 1px solid #000000; */
  border-radius: 1em;
  padding: 1em;
  width: 80%;
  text-align: center;
  color: #808080;
}

#inputEmail, #inputPassword{
  border-radius: 2em;
}

#LoginButton{
  background-color: #0089fb;
  border: 1px solid #0089fb;
  border-radius: 2em;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/* ----------------------- Old styling --------------------------- */

h3 {
  color: white;
}

/* #LoginForm{ background-image:url("https://hdwallsource.com/img/2014/9/blur-26347-27038-hd-wallpapers.jpg");  background-position:center; background-size:cover;} */
.LoginForm {
  background-color: #5b7fc8;
  height: 55em;
  padding-top: 5%;
}

.form-heading {
  color: #fff;
  font-size: 23px;
}

.panel h2 {
  color: #444444;
  font-size: 18px;
  margin: 0 0 8px 0;
}

.panel p {
  color: #777777;
  font-size: 14px;
  margin-bottom: 30px;
  line-height: 24px;
}

.login-form .form-control {
  background: #f7f7f7 none repeat scroll 0 0;
  border: 1px solid #d4d4d4;
  border-radius: 4px;
  font-size: 14px;
  height: 50px;
  line-height: 50px;
}

.error {
  color: red;
  font-size: 15px;
  font-weight: 15px;
}

.main-div {
  background: #5b7fc8 none repeat scroll 0 0;
  border-radius: 2px;
  margin: 10px auto 30px;
  max-width: 38%;
  padding: 50px 70px 70px 71px;
}

.login-form .form-group {
  margin-bottom: 10px;
}

.login-form {
  text-align: center;
}

.forgot a {
  color: #777777;
  font-size: 14px;
  text-decoration: underline;
}

.login-form .btn.btn-primary {
  background: #f0ad4e none repeat scroll 0 0;
  border-color: #f0ad4e;
  color: #ffffff;
  font-size: 14px;
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0;
}

.forgot {
  text-align: left;
  margin-bottom: 30px;
}

.botto-text {
  color: #ffffff;
  font-size: 14px;
  margin: auto;
}

.login-form .btn.btn-primary.reset {
  background: #ff9900 none repeat scroll 0 0;
}

.back {
  text-align: left;
  margin-top: 10px;
}

.back a {
  color: #444444;
  font-size: 13px;
  text-decoration: none;
}

.EnterMobile{
  border-radius: 2em;
}

.Next{
  border-radius: 2em;
  background-color: #458afc;
}
</style>




// WEBPACK FOOTER //
// src/components/SignUp.vue